import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button, TextField} from "@material-ui/core";
import FastForward from "@material-ui/icons/FastForward";
import FastRewind from "@material-ui/icons/FastRewind";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import NavigateNext from "@material-ui/icons/NavigateNext";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from 'react-router-dom';
import { useQueryString, modQueryPageNum } from "Hooks/useQueryString";

const useStyles = makeStyles((theme) => ({
  minimumWidth: {
    minWidth: 32,
  },
  currentPageButton: {
    color: '#fff',
    backgroundColor: '#556cd6',
  },
  formControl: {
    margin: theme.spacing(1),
  },
}));

const MyPagination = (props) => {
  const { count, currentPage, handlePagination, location, history } = props;
  const [pageNum, setPageNum] = React.useState(currentPage);
  const classes = useStyles();
  const queryParams = useQueryString();

  React.useEffect(() => {
    setPageNum(currentPage);
  }, [currentPage]);

  const handlePaging = (page) => {
    if (!page || count < page || page < 1) {
      return;
    }
    modQueryPageNum(queryParams, page);
    history.push(location.pathname + "?" + queryParams.toString());
    setPageNum(page);
    handlePagination(page);
  };

  if (!count || count < 2) {
    return null;
  }
  return (
    <React.Fragment>
      <Grid container justifyContent="center">
        <Button disabled={currentPage < 2} classes={{root: classes.minimumWidth}} onClick={() => handlePaging(1)}>1</Button>
        <Button disabled={currentPage < 11} classes={{root: classes.minimumWidth}} onClick={() => handlePaging(currentPage-10)}><FastRewind /></Button>
        <Button disabled={currentPage < 2} classes={{root: classes.minimumWidth}} onClick={() => handlePaging(currentPage-1)}><NavigateBefore /></Button>
        <TextField
          variant="outlined"
          type="number"
          size="small"
          style={{width: 90}}
          value={pageNum}
          onChange={(event) => { setPageNum(parseInt(event.target.value, 10)); }}
          onKeyDown={(event) => {
            if (event.keyCode === 13) {
              handlePaging(parseInt(event.target.value, 10));
            }
          }}
          InputProps={{
            inputProps: {
              min: 1, // 最小値
              max: count // 最大値
            }
          }}
          error={(!pageNum || count < pageNum || pageNum < 1) ? true : false}
        />
        <Button disabled={currentPage > count-1} classes={{root: classes.minimumWidth}} onClick={() => handlePaging(currentPage+1)}><NavigateNext /></Button>
        <Button disabled={currentPage > count-10} classes={{root: classes.minimumWidth}} onClick={() => handlePaging(currentPage+10)}><FastForward /></Button>
        <Button disabled={currentPage > count-1} classes={{root: classes.minimumWidth}} onClick={() => handlePaging(count)}>{count}</Button>
      </Grid>
      <Grid container justifyContent="center">
        <Button size="small" color="primary" onClick={() => handlePaging(pageNum)}>入力ページに遷移</Button>
      </Grid>
    </React.Fragment>
  );
}

export default withRouter(MyPagination);
